@import "~@govbr-ds/core/src/components/button/button";
@import "~@govbr-ds/core/src/components/loading/loading";

:host {
  display: inline-block;
}

:host([shape="block"]) {
  display: block;
}

::slotted(br-icon) {
  margin: 0 var(--spacing-scale-base);
}

::slotted(a:not(:disabled):hover) {
  background-image: none !important;
}
